const ILLEGAL = /[\/:\\?%*|"<>]/g;

export function sanitizeFilename(input: string): string {
  const trimmed = input.trim();
  const cleaned = trimmed.replace(ILLEGAL, "-").replace(/^-+|-+$/g, "");
  return cleaned.length === 0 ? "Scan" : cleaned;
}

function pad(n: number): string {
  return n.toString().padStart(2, "0");
}

function formatStamp(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}-${pad(date.getMinutes())}`;
}

export function defaultScanName(date: Date = new Date()): string {
  return `Scan ${formatStamp(date)}`;
}

export function defaultPhotoName(date: Date = new Date()): string {
  return `Photo ${formatStamp(date)}`;
}
